import { useCallback, useEffect, useRef } from 'react';
import _ from 'lodash';

// Source: https://stackoverflow.com/a/62017005
export const useThrottle = <T>(cb: T, delay: number) => {
  const options = { leading: true, trailing: false }; // pass custom lodash options
  const cbRef = useRef<any>(cb);
  useEffect(() => {
    cbRef.current = cb;
  });
  return useCallback(
    _.throttle((...args) => cbRef.current(...args), delay, options),
    [delay]
  );
};
